import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import * as React from 'react';
export const isHomeJumbo = (props)=>(props.kind == 'home' || props.kind == 'home-location') && !!props.localizationProps;
export const renderContents = (contents, htmlElement, jsxElement)=>{
    return typeof contents == 'string' ? /*#__PURE__*/ _createElement(htmlElement.type, {
        ...htmlElement.props,
        key: htmlElement.key,
        dangerouslySetInnerHTML: {
            __html: contents
        }
    }) : /*#__PURE__*/ _jsx(jsxElement.type, {
        ...jsxElement.props,
        children: contents
    }, jsxElement.key);
};
